const CONTRACT_ACCESS = {
    GET_X25_CENTERS: {
        url: '/x25Resolution/applications/:application/bankCodes/:bankCode',
        queryKey: 'getX25Centers'
    },
    COLLECTION: {
        url: '/organizations/:organizationId/contractsAccesses',
        queryKey: 'getMerchantAccounts'
    },
    DETAILS: {
        url: '/contractsAccesses/:contractAccessId'
    },
    USERS: {
        url: '/contractsAccesses/:contractAccessId/users'
    },
    TERMINALS: {
        url: '/contractsAccesses/:contractAccessId/posTerminalsData'
    },
    PERSONALIZATIONS: {
        url: '/contractsAccesses/:contractAccessId/personalizationsData'
    },
    CREATE: {
        url: '/contractsAccesses'
    },
    UPDATE_LABEL: {
        url: '/contractsAccesses/:contractAccessId'
    },
    UPDATE: {
        url: '/contractsAccesses/:contractAccessId/contractProfiles'
    },
    UPDATE_CONTRACT: {
        url: '/contractsAccesses/:contractAccessId/contracts/:contractId'
    },
    ACTIVATE: {
        url: '/contractsAccesses/:uuid/activate'
    },
    DEACTIVATE: {
        url: '/contractsAccesses/:uuid/deactivate'
    },
    ADD_USERS: {
        url: '/contractsAccesses/:uuid/users'
    },
    EXPORT_CONTRACTS: {
        url: '/contractsAccesses/:uuid/contracts/export'
    },
    EXPORT_CONTRACTS_ACCESSES: {
        url: '/contractsAccesses/export'
    },
    ADD_API_KEY: {
        url: '/externalApiKeyData'
    },
    ADD_VAD_CONTRACT: {
        url: '/contractsAccesses/:uuidContractAccess/externalContractProfile'
    },
    FILE_ACTION: {
        url: '/contractsAccesses/fileAction'
    },
    FETCH_PACKAGE_CUSTOMIZATION: {
        url: '/package/:packageId'
    },
    CREATE_PACKAGE_CUSTOMIZATION: {
        url: '/package'
    },
    UPDATE_PACKAGE_CUSTOMIZATION: {
        url: '/package/:uuid'
    },
    UPLOAD_PACKAGE_CUSTOMIZATION: {
        url: '/package/:uuid/publish'
    },
    DELETE_MULTIPLE_CONTRACTS: {
        url: '/contractsAccesses/:contractAccessId/contracts'
    }
};
export default CONTRACT_ACCESS;